import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class InvoicesService extends AxiosBase {
  getAllInvoices = async ({ page, limit }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BILLING_INVOICE.GET_ALL_INVOICES}?page=${page}&limit=${limit}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  getAllInvoicesByOrgId = async ({ page, limit, orgId }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BILLING_INVOICE.GET_ALL_INVOICES_SUPER_ADMIN}?page=${page}&limit=${limit}&orgId=${orgId}`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  getInvoiceApprovalList = async ({ page, limit }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BILLING_INVOICE.GET_INVOICES_APRROVAL}?page=${page}&limit=${limit}&status=open&scopeType=invoice_approvals`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  approvalInvoice = async (invoiceId) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BILLING_INVOICE.GET_ALL_INVOICES}/${invoiceId}/invoiceApproval`
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  updateInvoiceStatus = async (invoiceId, status) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.BILLING_INVOICE.GET_INVOICES_APRROVAL}/${invoiceId}`,
        { status }
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
}
